var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement } from '../../utils/WebComponentsUtil.js';
import { resetStyles } from '../../utils/ThemeUtil.js';
import '../../components/wui-text/index.js';
import '../wui-transaction-visual/index.js';
import styles from './styles.js';
let WuiTransactionListItemLoader = class WuiTransactionListItemLoader extends LitElement {
    render() {
        return html `
      <wui-flex alignItems="center">
        <wui-shimmer width="40px" height="40px"></wui-shimmer>
        <wui-flex flexDirection="column" gap="2xs">
          <wui-shimmer width="72px" height="16px" borderRadius="4xs"></wui-shimmer>
          <wui-shimmer width="148px" height="14px" borderRadius="4xs"></wui-shimmer>
        </wui-flex>
        <wui-shimmer width="24px" height="12px" borderRadius="5xs"></wui-shimmer>
      </wui-flex>
    `;
    }
};
WuiTransactionListItemLoader.styles = [resetStyles, styles];
WuiTransactionListItemLoader = __decorate([
    customElement('wui-transaction-list-item-loader')
], WuiTransactionListItemLoader);
export { WuiTransactionListItemLoader };
//# sourceMappingURL=index.js.map